import { render, staticRenderFns } from "./CargarImagen.vue?vue&type=template&id=2df1cab8&scoped=true"
import script from "./CargarImagen.vue?vue&type=script&lang=js"
export * from "./CargarImagen.vue?vue&type=script&lang=js"
import style0 from "./CargarImagen.vue?vue&type=style&index=0&id=2df1cab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df1cab8",
  null
  
)

export default component.exports